import apiClient from "@/services/apiClient";

const createNotificationService = (basePath) => ({
  async getAll(params = {}) {
    const { data } = await apiClient.get(basePath, { params });
    return {
      unreadCount: Number(data?.unreadCount ?? data?.UnreadCount ?? 0),
      notifications: data?.notifications ?? data?.Notifications ?? [],
      totalRecords: Number(data?.totalRecords ?? data?.TotalRecords ?? 0),
      totalPages: Number(data?.totalPages ?? data?.TotalPages ?? 1),
      page: Number(data?.page ?? data?.Page ?? params.page ?? 1),
      pageSize: Number(data?.pageSize ?? data?.PageSize ?? params.pageSize ?? 10),
    };
  },
  async getUnreadCount() {
    const { data } = await apiClient.get(`${basePath}/unread-count`);
    return Number(data?.unreadCount ?? data?.UnreadCount ?? 0);
  },
  async markRead(notificationId) {
    await apiClient.put(`${basePath}/${notificationId}/read`);
  },
  async markAllRead() {
    await apiClient.put(`${basePath}/read-all`);
  },
});

export const studentNotificationService = createNotificationService("/StudentNotifications");
export const adminNotificationService = createNotificationService("/AdminNotifications");
